import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/designSystem/Dialog';
import { Button } from '@/designSystem/Button';
import { Calendar, Clock, Star, X, Video } from 'lucide-react';

interface BookDemoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const googleCalendarURL = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2nH1tqF2J9fQa7_Yfw-aENTVJBIGOS0aif14dA6HBTwCulJhqHCDWKcRp6U1I_zw0104pdOq3I?gv=true'

const BookDemoModal: React.FC<BookDemoModalProps> = ({
  isOpen,
  onClose,
}) => {
  const handleBookCall = () => {
    window.open(googleCalendarURL, '_blank');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="mb-4">
          <DialogTitle className="text-xl">Unlock Premium Recommendations</DialogTitle>
          <DialogDescription>
            Book a consultation call with our optimization experts to unlock advanced recommendations for your portoflio.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="bg-blue-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2 flex items-center text-blue-700">
              <Star className="mr-2" size={16} /> What you'll get from the consultation
            </h3>
            <ul className="text-sm space-y-2">
              <li className="flex items-start">
                <div className="bg-blue-200 rounded-full p-1 mr-2 mt-0.5">
                  <Video size={12} className="text-blue-700" />
                </div>
                <span>Personalized 45-minute Google Meet strategy session</span>
              </li>
              <li className="flex items-start">
                <div className="bg-blue-200 rounded-full p-1 mr-2 mt-0.5">
                  <Clock size={12} className="text-blue-700" />
                </div>
                <span>Immediate access to all premium recommendations</span>
              </li>
              <li className="flex items-start">
                <div className="bg-blue-200 rounded-full p-1 mr-2 mt-0.5">
                  <Star size={12} className="text-blue-700" />
                </div>
                <span>Custom implementation guidance from our expert founders</span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Choose your preferred option:</h3>
            <Button
              variant="default"
              onClick={handleBookCall}
              className="mt-3 w-full flex items-center justify-center bg-blue-600 hover:bg-blue-700"
            >
              <Calendar size={16} className="mr-2" /> Book a Demo
            </Button>
          </div>
        </div>

        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto">
            Maybe Later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BookDemoModal;